"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _luxon = require("luxon");

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _reactVis = require("react-vis");

var _SplitLineSeries = _interopRequireDefault(require("../SplitLineSeries"));

var _SplitAreaSeries = _interopRequireDefault(require("../SplitAreaSeries"));

var _ResizableXYPlot = _interopRequireDefault(require("../ResizableXYPlot"));

var _noDataInsert = _interopRequireDefault(require("../noDataInsert"));

var _styles = require("../../styles");

var _chartUtils = require("../../chartUtils");

require("react-vis/dist/style.css");

var _colors = require("../../constants/colors");

var _propTypes2 = require("../../constants/propTypes");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var getXAxisTickInfo = (0, _memoizeOne["default"])(function (viewStartDateTime, viewEndDateTime, timeZone) {
  return (0, _chartUtils.getTickInfoByInterval)({
    endDate: viewEndDateTime,
    startDate: viewStartDateTime,
    timeZone: timeZone
  });
});

var Display = function Display(_ref) {
  var displayCoordinates = _ref.displayCoordinates,
      hasBattery = _ref.hasBattery,
      isLoading = _ref.isLoading,
      timeZone = _ref.timeZone,
      viewEndISO = _ref.viewEndISO,
      viewStartISO = _ref.viewStartISO;
  var batteryChargeCoordinates = displayCoordinates.batteryChargeCoordinates,
      batteryDischargeCoordinates = displayCoordinates.batteryDischargeCoordinates,
      consumptionCoordinates = displayCoordinates.consumptionCoordinates,
      contractCoordinates = displayCoordinates.contractCoordinates,
      estimatedSolarCoordinates = displayCoordinates.estimatedSolarCoordinates,
      exportCoordinates = displayCoordinates.exportCoordinates,
      importCoordinates = displayCoordinates.importCoordinates,
      peerCoordinates = displayCoordinates.peerCoordinates,
      peerV2Coordinates = displayCoordinates.peerV2Coordinates,
      selfConsumptionCoordinates = displayCoordinates.selfConsumptionCoordinates,
      solarCoordinates = displayCoordinates.solarCoordinates,
      systemProductionCoordinates = displayCoordinates.systemProductionCoordinates;

  var viewStartDateTime = _luxon.DateTime.fromISO(viewStartISO, {
    zone: timeZone
  });

  var viewEndDateTime = _luxon.DateTime.fromISO(viewEndISO, {
    zone: timeZone
  });

  var startMillis = viewStartDateTime.toMillis();
  var endMillis = viewEndDateTime.toMillis();
  var tickInfo = getXAxisTickInfo(viewStartDateTime, viewEndDateTime, timeZone);
  return /*#__PURE__*/_react["default"].createElement(_ResizableXYPlot["default"], {
    dataTestid: "monthly-chart",
    animation: false,
    height: 300,
    margin: {
      left: 70,
      right: 0
    },
    xDomain: [startMillis, endMillis],
    xType: "time"
  }, /*#__PURE__*/_react["default"].createElement(_reactVis.GradientDefs, null, /*#__PURE__*/_react["default"].createElement("pattern", {
    id: "export-crosshatch",
    width: "4",
    height: "4",
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    className: "vx-pattern-line",
    d: "M 0,4 l 4,-4 M -1,1 l 2,-2 M 3,5 l 2,-2",
    stroke: _colors.DARK_GREY,
    strokeWidth: "1",
    strokeLinecap: "square",
    shapeRendering: "auto"
  }))), /*#__PURE__*/_react["default"].createElement(_reactVis.HorizontalGridLines, {
    style: _styles.dashedGridStyle
  }), _noDataInsert["default"].apply(void 0, [startMillis, endMillis, isLoading].concat(_toConsumableArray(Object.values(displayCoordinates)))), /*#__PURE__*/_react["default"].createElement(_SplitAreaSeries["default"], {
    data: solarCoordinates,
    delta: 1,
    style: _styles.solarAreaStyle,
    unit: "day"
  }), /*#__PURE__*/_react["default"].createElement(_SplitAreaSeries["default"], {
    data: estimatedSolarCoordinates,
    delta: 1,
    style: _styles.estimatedSolarAreaStyle,
    unit: "day"
  }), hasBattery && [/*#__PURE__*/_react["default"].createElement(_SplitAreaSeries["default"], {
    data: batteryChargeCoordinates,
    delta: 1,
    key: "chargeSeries",
    style: _styles.batteryChargeStyle,
    unit: "day"
  }), /*#__PURE__*/_react["default"].createElement(_SplitAreaSeries["default"], {
    data: batteryDischargeCoordinates,
    delta: 1,
    key: "dischargeSeries",
    style: _styles.batteryDischargeStyle,
    unit: "day"
  })], /*#__PURE__*/_react["default"].createElement(_SplitAreaSeries["default"], {
    data: selfConsumptionCoordinates,
    delta: 1,
    key: "selfConsumptionSeries",
    style: _styles.selfConsumptionAreaStyle,
    unit: "day"
  }), /*#__PURE__*/_react["default"].createElement(_SplitAreaSeries["default"], {
    data: exportCoordinates,
    delta: 1,
    key: "exportSeries",
    style: _styles.exportCrosshatchStyle,
    unit: "day"
  }), /*#__PURE__*/_react["default"].createElement(_SplitAreaSeries["default"], {
    data: importCoordinates,
    delta: 1,
    key: "importSeries",
    style: _styles.importCrosshatchStyle,
    unit: "day"
  }), hasBattery && /*#__PURE__*/_react["default"].createElement(_SplitLineSeries["default"], {
    data: systemProductionCoordinates,
    delta: 1,
    key: "systemProductionSeries",
    style: _styles.systemProductionLineStyle,
    unit: "day"
  }), /*#__PURE__*/_react["default"].createElement(_SplitLineSeries["default"], {
    curve: "curveLinear",
    data: peerV2Coordinates,
    delta: 1,
    key: "peerV2Series",
    style: _styles.peerV2LineStyle,
    unit: "day"
  }), /*#__PURE__*/_react["default"].createElement(_SplitLineSeries["default"], {
    curve: "curveLinear",
    data: peerCoordinates,
    delta: 1,
    key: "peerSeries",
    style: _styles.peerAdjGenerationsLineStyle,
    unit: "day"
  }), /*#__PURE__*/_react["default"].createElement(_SplitLineSeries["default"], {
    curve: "curveLinear",
    data: contractCoordinates,
    delta: 1,
    key: "contractSeries",
    style: _styles.contractGenerationsLineStyle,
    unit: "day"
  }), /*#__PURE__*/_react["default"].createElement(_SplitLineSeries["default"], {
    data: consumptionCoordinates,
    delta: 1,
    key: "consumptionSeries",
    style: _styles.consumptionLineStyle,
    unit: "day"
  }), /*#__PURE__*/_react["default"].createElement(_reactVis.XAxis, {
    key: "monthlyXAxis",
    style: _objectSpread(_objectSpread({}, _styles.axisStyle), {}, {
      text: {
        textAnchor: 'start',
        fontSize: 12,
        fill: _colors.NAVY
      }
    }),
    tickValues: tickInfo.values,
    tickFormat: tickInfo.formats
  }));
};

Display.propTypes = {
  displayCoordinates: _propTypes["default"].shape({
    batteryChargeCoordinates: _propTypes2.coordinatePropTypes,
    batteryDischargeCoordinates: _propTypes2.coordinatePropTypes,
    consumptionCoordinates: _propTypes2.coordinatePropTypes,
    contractCoordinates: _propTypes2.coordinatePropTypes,
    estimatedSolarCoordinates: _propTypes2.coordinatePropTypes,
    exportCoordinates: _propTypes2.coordinatePropTypes,
    importCoordinates: _propTypes2.coordinatePropTypes,
    peerCoordinates: _propTypes2.coordinatePropTypes,
    peerV2Coordinates: _propTypes2.coordinatePropTypes,
    selfConsumptionCoordinates: _propTypes2.coordinatePropTypes,
    solarCoordinates: _propTypes2.coordinatePropTypes,
    systemProductionCoordinates: _propTypes2.coordinatePropTypes
  }),
  hasBattery: _propTypes["default"].bool,
  isLoading: _propTypes["default"].bool,
  timeZone: _propTypes["default"].string,
  viewEndISO: _propTypes["default"].string.isRequired,
  viewStartISO: _propTypes["default"].string.isRequired
};
Display.defaultProps = {
  displayCoordinates: {},
  hasBattery: false,
  isLoading: false,
  timeZone: 'local'
};
var _default = Display;
exports["default"] = _default;